import { GENERAL_GLOBAL_REDUCER, SEND_ALERT, RESET_ALERT, } from "./types";
const initialState = {
    alert: {
        title: null,
        textContent: null,
        buttonLeftText: null,
        buttonLeftPress: null,
        buttonRightText: null,
        buttonRightPress: null,
        otherContent: null,
    },
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_GLOBAL_REDUCER:
            return {
                ...state,
                ...action.payload,
            };
        case SEND_ALERT:
            return {
                ...state,
                alert: {
                    ...state.alert,
                    ...action.payload,
                },
            };
        case RESET_ALERT:
            return {
                ...state,
                alert: initialState.alert,
            };
        default:
            return state;
    }
};
